import { render, staticRenderFns } from "./PostingDetail.vue?vue&type=template&id=2a7d9d7a"
import script from "./PostingDetail.vue?vue&type=script&lang=js"
export * from "./PostingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports